import { render, staticRenderFns } from "./CargoShipment.vue?vue&type=template&id=414484d1&"
import script from "./CargoShipment.vue?vue&type=script&lang=js&"
export * from "./CargoShipment.vue?vue&type=script&lang=js&"
import style0 from "./CargoShipment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoShipment.vue"
export default component.exports